import { bootstrapApplication } from "@angular/platform-browser"
import { appConfig } from "./app/app.config"
import { AppComponent } from "./app/app.component"
import { environment } from "./environments/environment"

function loadGoogleMapsScript(): Promise<void> {
	const win = window as typeof window & { google?: { maps?: unknown } }
	if (win.google && win.google.maps) {
		return Promise.resolve()
	}
	return new Promise((resolve, reject) => {
		const script = document.createElement("script")
		script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.map.key}&libraries=places,marker&v=weekly&language=it`
		script.async = true
		script.defer = true
		script.onload = () => resolve()
		script.onerror = () => reject("Impossibile caricare Google Maps")
		document.head.appendChild(script)
	})
}

loadGoogleMapsScript()
	.then(() => {
		bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
	})
	.catch(err => {
		console.error("Errore caricamento Google Maps:", err)
	})
